import React from "react";

export default function NotFound() {
  return (
    <main className="container main">
      <div className="card">
        <h2 className="card__title">Página não encontrada</h2>
        <p className="card__text">Verifique o endereço.</p>
      </div>
    </main>
  );
}